import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {DatePicker, Select, Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {
  StyledTableFiltersSearch,
  StyledTableFilters,
  StyledTableFiltersElements,
} from './StyledTableFilters';
import {dateHelpers, formHelpers, SyncStatusOptions} from '../../../../utils/helpers';

const TableFilters = ({
  dateFilterName = 'posting_date',
  leftSideContent,
  onFilter,
  statusOptions = [],
  rightSideContent,
  filterFields = ['search'],
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [values, setValues] = useState({
    invoice_date_start: null,
    invoice_date_end: null,
    posting_date_start: null,
    posting_date_end: null,
    sync_status: [],
    search: '',
  });

  const [componentStatusOptions, ] = useState(statusOptions.length ? statusOptions : [
    {label: t('allStatuses'), value: 'all'},
    ...SyncStatusOptions(),
  ]);

  const handleOnFilter = (key, value) => {
    const dateFormat = 'YYYY-MM-DD';
    const isDateRange = key === 'dateRange';
    const updatedValues = isDateRange
      ? {
          [`${dateFilterName}_start`]: value?.[0] || null,
          [`${dateFilterName}_end`]: value?.[1] || null,
        }
      : { [key]: value };

    setValues(prev => ({ ...prev, ...updatedValues }));

    const formattedValues = isDateRange
      ? {
          [`${dateFilterName}_start`]: value?.[0]?.format(dateFormat) || null,
          [`${dateFilterName}_end`]: value?.[1]?.format(dateFormat) || null,
        }
      : { [key]: value };

    onFilter?.(formattedValues);
  };

  const renderFilterField = (field) => {
    const filterComponents = {
      search: (
        <StyledTableFiltersSearch
          allowClear
          key='search'
          minSearchSymbolsLength={1}
          onSearch={(value) => handleOnFilter('search', value)}
          placeholder={t('search')}
          size='large'
          value={values.search}
        />
      ),
      status: (
        <Select
          key='sync_status'
          onChange={(value) => handleOnFilter('sync_status', value)}
          options={formHelpers.getStatusOptions(componentStatusOptions)}
          placeholder={t('allStatuses')}
          size='large'
          value={values.sync_status}
        />
      ),
      daterange: (
        <DatePicker.RangePicker
          key='daterange'
          panelRender={dateHelpers.getDatePickerPanelRender}
          onChange={(value) => handleOnFilter('dateRange', value)}
          format='DD MMM YYYY'
          size='middle'
          superNextIcon={false}
          superPrevIcon={false}
          value={[values.posting_date_start, values.posting_date_end]}
        />
      ),
    };
    return filterComponents[field] || null;
  };

  return (
    <StyledTableFilters {...rest}>
      <StyledTableFiltersElements>
        <Space size='small' align='center'>
          {Array.isArray(filterFields)
            ? filterFields.map(renderFilterField)
            : renderFilterField(filterFields)}
          {leftSideContent}
        </Space>
        {rightSideContent && (
          <div className='table-filters-right-side-content'>{rightSideContent}</div>
        )}
      </StyledTableFiltersElements>
    </StyledTableFilters>
  );
};

TableFilters.propTypes = {
  dateFilterName: PropTypes.oneOf(['posting_date', 'transaction_date']),
  filterFields: PropTypes.arrayOf(PropTypes.oneOf(['status', 'search', 'daterange'])),
  onFilter: PropTypes.func,
  rightSideContent: PropTypes.any
}

export default TableFilters;
